export default __webpack_public_path__ + "static/media/iPadSS6.f366a7b4.png";